import { StudentActivitiesModel } from '@/models/data-lake/data-lake';
import { dataLakeAPI } from '@/providers/apis/data-lake/data-lake';
import { Vue, Component, Prop } from 'vue-property-decorator';

@Component({
    name: 'activities-table',
})

export default class ActivitiesTable extends Vue {

    // ----------------------------------------------------------
    // Properties

    @Prop()
    private dateRange: any;

    private activitiesData: StudentActivitiesModel[] = [];

    private currentPage: number = 1;

    private perPage: number = 10;

    private totalStats: any = {};

    private vendorList: any = [];

    private studentList: any = [];

    private offset: number = 0;

    private isLoading: boolean = false;

    private searchTerms: string = '';

    // -------------------------------------------------------------
    // Hooks

    private created() {
        this.onLoadData();
    }

    // -------------------------------------------------------------
    // Actions

    private onGoBack() {
        this.$router.push('/data-lake-report');
    }

    private onChangePage(page: any) {
        this.currentPage = page;
        if (page * this.perPage > this.activitiesData.length) {
            this.offset = (page - 1) * this.perPage;
            this.onLoadData();
        } else {
            this.customPagination();
        }
    }

    private onSearch() {
        this.activitiesData = [];
        this.onLoadData();
    }

    // -------------------------------------------------------------
    // Methods

    private onLoadData() {
        const dateRange = this.dateRange;
        this.isLoading = true;
        const params = {
            // startDate: dateRange.startDate,
            // endDate: dateRange.endDate,
            limit: this.perPage,
            offset: this.offset,
            query: this.searchTerms,
        };

        dataLakeAPI.fetchActivitiesByStudent(params).then((studentData: any) => {
            this.activitiesData = [...this.activitiesData, ...studentData];
            this.fetchVendorList();
            this.totalStats = {
                activityCount: studentData.reduce((a: any, b: any) => a + b.activityCount, 0),
            };
            this.isLoading = false;
        });
    }


    private fetchVendorList() {
        const studentList = this.activitiesData;
        let vendorList = [];
        const vendorMapping = studentList.map((student) => student.toolList.map((item) => item.toolName));
        vendorList = vendorMapping.flat(1);
        this.vendorList = [...new Set(vendorList)];
        this.customPagination();
    }

    private customPagination() {
        const startPosition = (this.currentPage - 1) * this.perPage;
        const limit = this.perPage + startPosition;
        this.studentList = [...this.activitiesData].slice(startPosition, limit);
    }
}
